/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CommEmail: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M20 5C21.1046 5 22 5.89543 22 7V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V7C2 5.89543 2.89543 5 4 5H20ZM13.2275 13.3115C12.5505 13.8381 11.6199 13.8709 10.9111 13.4102L10.7725 13.3115L4 8.04395V16.7539L7.33105 13.7568C7.74155 13.3874 8.3737 13.4206 8.74316 13.8311C9.11261 14.2415 9.0794 14.8737 8.66895 15.2432L5.60547 18H18.3945L15.3311 15.2432C14.9206 14.8737 14.8874 14.2415 15.2568 13.8311C15.6263 13.4206 16.2585 13.3874 16.6689 13.7568L20 16.7539V8.04395L13.2275 13.3115ZM12 11.7334L18.0859 7H5.91406L12 11.7334Z'
      fill='currentColor'
    />
  </React.Fragment>
)
